export const MAX_VISIBLE_SUGGESTIONS = 6; // Maximum suggestions to show initially

export const CONTEXT_TYPES = {
  ALERT: 'alert',
  DEVICE: 'device',
  ENTITY_FOCUS: 'entity_focus',
  ENTITY_HOVER: 'entity_hover',
  TOPOLOGY_LOADED: 'topology_loaded',
  TOPOLOGY_OVERVIEW: 'topology_overview',
  DATA_EXPLORER: 'data_explorer'
};

export const AI_DISCLAIMER_SHORT = 'This content is generated using AI. Please verify important information.';
